import PropTypes from 'prop-types';
import { spacingLabels } from '../themes';
export const spacingPropTypes = {
    /** Spacing following CSS shorthand notation with one to four values */
    spacing: PropTypes.arrayOf(PropTypes.oneOf(spacingLabels)),
    /** Space applied to block axis start side */
    spaceStackStart: PropTypes.oneOf(spacingLabels),
    /** Space applied to block axis end side */
    spaceStackEnd: PropTypes.oneOf(spacingLabels),
    /** Space applied to inline axis start side */
    spaceInlineStart: PropTypes.oneOf(spacingLabels),
    /** Space applied to inline axis end side */
    spaceInlineEnd: PropTypes.oneOf(spacingLabels),
};
export const spacingInsetPropTypes = {
    /** Spacing following CSS shorthand notation with one to four values */
    spacingInset: PropTypes.arrayOf(PropTypes.oneOf(spacingLabels)),
    /** Space applied to block axis start side */
    spaceInsetStackStart: PropTypes.oneOf(spacingLabels),
    /** Space applied to block axis end side */
    spaceInsetStackEnd: PropTypes.oneOf(spacingLabels),
    /** Space applied to inline axis start side */
    spaceInsetInlineStart: PropTypes.oneOf(spacingLabels),
    /** Space applied to inline axis end side */
    spaceInsetInlineEnd: PropTypes.oneOf(spacingLabels),
};
//# sourceMappingURL=layoutProps.js.map